module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Aquaman.facef51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Aquaman.jpg
// module id = Ghwy
// module chunks = 0